import { useState } from 'react';

export default function ResetPasswordPage({ onUpdatePassword }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      setMsg({ type: 'error', text: 'A senha deve ter pelo menos 6 caracteres.' });
      return;
    }
    if (password !== confirm) {
      setMsg({ type: 'error', text: 'As senhas não coincidem.' });
      return;
    }
    setLoading(true);
    setMsg(null);
    const error = await onUpdatePassword(password);
    setLoading(false);
    if (error) {
      setMsg({ type: 'error', text: error.message });
    } else {
      setSuccess(true);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">🔐</div>
        <h1>Nova senha</h1>
        <p className="auth-subtitle">Escolha uma nova senha para sua conta.</p>

        {success ? (
          <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 12 }}>
            <p className="msg msg-success">Senha redefinida com sucesso! ✓</p>
            <p style={{ fontSize: '.9rem', color: 'var(--text-muted)' }}>
              Você será redirecionada para o app em instantes...
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="form-label">Nova senha</label>
              <input
                className="input"
                type="password"
                placeholder="Mínimo 6 caracteres"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="form-label">Confirmar senha</label>
              <input
                className="input"
                type="password"
                placeholder="Repita a nova senha"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                required
              />
            </div>
            {msg && (
              <p className={`msg ${msg.type === 'error' ? 'msg-error' : 'msg-success'}`}>
                {msg.text}
              </p>
            )}
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Salvando...' : 'Redefinir senha'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
